import { MONTHS } from '@/constants/constants'

export const formatDate = (date: string) => {
  const dateObject = new Date(date)

  const month = MONTHS[dateObject.getMonth()]
  const day = dateObject.getDate()
  const hours = dateObject.getHours()
  const minutes = String(dateObject.getMinutes()).padStart(2, '0')

  return `${month} ${day}, ${hours}:${minutes}`
}
